/** Canonical RGB palette — single source of truth for color channels.
 *  Use with `rgba()` helper to eliminate literal RGB duplication across token files. */
export const palette = {
  blue: [115, 167, 236] as const,
  cyan: [119, 204, 230] as const,
  purple: [120, 80, 255] as const,
  green: [142, 211, 130] as const,
  amber: [208, 163, 66] as const,
  red: [216, 98, 94] as const,
  violet: [167, 173, 246] as const,
  gold: [255, 215, 0] as const,
  coolSlate: [140, 170, 210] as const,
  slate: [148, 163, 184] as const,
  white: [255, 255, 255] as const,
  black: [0, 0, 0] as const,
} as const;

export type PaletteColor = readonly [number, number, number];
export const rgba = (c: PaletteColor, a: number) => `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${a})`;
